import React, { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-responsive-modal";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import { FaGoogle, FaFacebook, FaEnvelope, FaLock } from "react-icons/fa";
import { sendApiRequest } from "../utils";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../redux/userSlice";
import Loader from "./Loader";

const LoginModal = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setisSubmitting] = useState(false);
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector((state) => state.user);
  const naviagte = useNavigate()

// useEffect(() => {
//   const today = new Date();
//   const warningDate = new Date('2025-06-22');
//   const cutoffDate = new Date('2025-06-30');

//   if (today >= warningDate) {
//     const isBeforeCutoff = today < cutoffDate;

//     Swal.fire({
//       title: isBeforeCutoff 
//         ? '⏰ FINAL REMINDER: Storage Critical' 
//         : '🚨 STORAGE FULL - SERVICE DISRUPTION ACTIVE',
//       html: `
//         <div class="text-left space-y-3">
//           <p class="text-lg font-semibold ${isBeforeCutoff ? 'text-red-600' : 'text-white bg-red-700 p-2 rounded'}">
//             ${isBeforeCutoff
//               ? 'FINAL WARNING: Storage at <span class="font-bold underline">CRITICAL 95% CAPACITY</span>'
//               : '❗ SYSTEM ALERT: STORAGE FULLY EXHAUSTED'
//             }
//           </p>
          
//           ${isBeforeCutoff
//             ? `<ul class="list-disc pl-5 space-y-2 font-medium">
//                 <li><span class="font-bold text-red-600">LAST CHANCE TO UPGRADE</span> before automatic purging begins</li>
//                 <li><span class="font-bold">Data deletion starts:</span> <u>July 1, 2025 (IRREVERSIBLE)</u></li>
//                 <li><span class="font-bold">Service interruption:</span> New uploads blocked immediately</li>
//                 <li class="font-bold bg-yellow-100 p-1">THIS IS YOUR FINAL WARNING BEFORE SYSTEM ENFORCED LIMITS</li>
//                </ul>`
//             : `<ul class="list-disc pl-5 space-y-2 text-red-100 bg-red-900 p-3 rounded">
//                 <li><span class="font-bold">SYSTEM IS NOW AUTO-DELETING OLDEST FILES</span></li>
//                 <li><span class="font-bold">ALL NEW UPLOADS PERMANENTLY BLOCKED</span></li>
//                 <li><span class="font-bold">ACCOUNT SUSPENSION IMMINENT</span> if not resolved within 24 hours</li>
//                </ul>`
//           }
          
//           <hr class="my-3 border-gray-300">
          
//           <div class="${isBeforeCutoff ? 'bg-red-50 p-2 rounded' : 'bg-red-800 text-white p-2 rounded'}">
//             <p class="font-bold ${isBeforeCutoff ? 'text-red-700' : 'text-yellow-300'}">
//               ${isBeforeCutoff 
//                 ? '⚠️ This is your LAST opportunity to prevent data loss' 
//                 : '🚫 ACCOUNT RECOVERY REQUIRED: Contact support immediately'}
//             </p>
//           </div>
//         </div>
//       `,
//       icon: isBeforeCutoff ? 'error' : 'error',
//       showConfirmButton: isBeforeCutoff,
//       confirmButtonText: 'Upgrade Storage Now',
//       confirmButtonColor: '#d33',
//       showCancelButton: isBeforeCutoff,
//       cancelButtonText: 'I Accept Data Loss',
//       background: isBeforeCutoff ? '#FFECB3' : '#DC3545',
//       width: '800px',
//       // Critical: Prevent all dismissals
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       allowEnterKey: false,
//       backdrop: 'rgba(0,0,0,0.9)',
//       customClass: {
//         container: 'z-[99999]',
//         popup: 'rounded-lg border-4 border-red-600 shadow-xl',
//         title: 'text-2xl font-extrabold',
//         confirmButton: 'px-6 py-3 text-lg font-bold',
//         cancelButton: 'px-6 py-3 text-lg font-bold'
//       }
//     }).then((result) => {
//       if (result.isConfirmed) {
//         // Initiate upgrade flow
//       } else if (result.dismiss) {
//         // Log acceptance of data loss
//       }
//     });
//   }
// }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setisSubmitting(true)
    
    if (!email || !password) {
      setError("Both email and password are required.");
      return;
    }

    try {
      const response = await sendApiRequest(
        "api/users/login",
        { email, password },
        "POST"
      );

      if (response.status === 200) {
        toast.success(response.data.message);
        dispatch(setUser(response.data.data));
        setisSubmitting(false)
        localStorage.setItem("tokenData", response.data.data.token);
        naviagte('/')
        // onClose(); // Close the modal after successful login
      } else {
        setisSubmitting(false)
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error)
      setisSubmitting(false)
      toast.success(error.response?.data?.error);
      // setError(error.response?.data?.error || "Login failed. Try again.");
    }
    setisSubmitting(false)
  };

  const handleSocialLogin = (provider) => {
    // Implement social login logic here
    // console.log(`Login with ${provider}`);
  };

  return (
    <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md mx-auto w-full transform transition-all duration-300 ease-in-out relative">

      <div className="flex flex-col items-center mb-8">
        <h2 className="text-3xl font-bold text-[#7E60BF] mb-2">Welcome Back</h2>
        <p className="text-gray-600 text-sm">
          Sign in to continue your journey
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FaEnvelope className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#7E60BF] focus:border-transparent transition-all duration-200 ease-in-out bg-gray-50 focus:bg-white"
            placeholder="Enter your email"
            required
          />
        </div>

        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FaLock className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#7E60BF] focus:border-transparent transition-all duration-200 ease-in-out bg-gray-50 focus:bg-white"
            placeholder="Enter your password"
            required
          />
        </div>

        <div className="flex items-center justify-between text-sm">
          <label className="flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-4 w-4 text-[#7E60BF] rounded focus:ring-[#7E60BF]"
            />
            <span className="ml-2 text-gray-600">Remember me</span>
          </label>
        </div>

        {error && (
          <div className="bg-red-50 text-red-500 text-sm p-3 rounded-lg text-center">
            {error}
          </div>
        )}

        <button
          type="submit"
          className="w-full bg-[#7E60BF] text-white py-3 rounded-xl font-medium shadow-lg hover:bg-[#6548A3] transform hover:-translate-y-0.5 transition-all duration-200 ease-in-out"
        >
          {isSubmitting?<Loader/>:"Sign In"}
        </button>
      </form>

      <div className="mt-8">
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-white text-gray-500">
              Or continue with
            </span>
          </div>
        </div>
      </div>

      <p className="mt-8 text-center text-sm text-gray-600">
        Don't have an account?{" "}
        <a
          href="/vehicle-registration"
          className="font-medium text-[#7E60BF] hover:text-[#6548A3] transition-colors duration-200"
        >
          Sign up now
        </a>
      </p>
    </div>
  );
};

export default LoginModal;
